import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import API from "../../apis"
const SidebarContent = props => {
  const ref = useRef()
  //
  var lng = localStorage.getItem("I18N_LANGUAGE")
  var userAuthEtudiant = JSON.parse(localStorage.getItem("userAuthEtudiant"))
  var mastere = userAuthEtudiant.user.mastere
  var verif = userAuthEtudiant.user.verif
  var niveau_id = userAuthEtudiant.user.niveau_id
  var cycle_id = userAuthEtudiant.user.cycle_id
  var id_etudiant = userAuthEtudiant.user.id_etudiant
  var annee_id = userAuthEtudiant.user.annee_id
  var etat_orientation = userAuthEtudiant.user.etat_orientation
  const [etat, setEtat] = useState(0)
  const [active, setActive] = useState(0)
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
    API.post("orientation_config/check_ouverture", {
      annee_id: annee_id,
    }).then(resEtat => {
      setEtat(resEtat.data.Orientation)
      setActive(resEtat.data.Orientation)
      if ( resEtat.data.Orientation == 0 && resEtat.data.Orientation == 1 ) {
        const style = document.createElement("style")
        style.innerHTML = `
      @keyframes blink {
        0%, 100% { opacity: 1; }
        50% { opacity: 0; }
      }

      .blinking {
        animation: blink 1s step-start infinite;
        color: #f00!important;
      }
    `
        document.head.appendChild(style)
      }
    })
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu" className={lng == "ar" ? "sidebar-menu-ar" : ""}>
          <ul
            className={
              lng == "ar"
                ? "metismenu-ar list-unstyled"
                : "metismenu list-unstyled"
            }
            id="side-menu"
          >
            <li>
              <Link to="/dashboard" className="">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Actualités")}</span>
              </Link>
            </li>
            <li>
              <Link to="/Emploi" className="">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Emploi du temps")}</span>
              </Link>
            </li>
            <li>
              <Link to="/#" className="has-arrow ">
                <i className="fas fa-calendar-alt"></i>
                <span>{props.t("Calendrier examen")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/CalendrierExamen">{props.t("Principale")}</Link>
                </li>
                <li>
                  <Link to="/CalendrierExamenControle">
                    {props.t("Contrôle")}
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/CalendrierDS1" className="">
                <i className="fas fa-calendar-alt"></i>
                <span>{props.t("Calendrier DS1")}</span>
              </Link>
            </li>
            <li>
              <Link to="/CalendrierDS2" className="">
                <i className="fas fa-calendar-alt"></i>
                <span>{props.t("Calendrier DS2")}</span>
              </Link>
            </li>

            {verif != 1 ? (
              <li>
                <Link to="/Demands" className="">
                  <i className="fas fa-solid fa-clipboard-list"></i>
                  <span>{props.t("Demandes")}</span>
                </Link>
              </li>
            ) : null}
            <li>
              <Link to="/#" className="has-arrow ">
                <i className="fas fa-graduation-cap"></i>
                <span>{props.t("Notes examens")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/Result">{props.t("Principale")}</Link>
                </li>
                <li>
                  <Link to="/ResultContole">{props.t("Contrôle")}</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow ">
                <i className="fas fa-graduation-cap"></i>
                <span>{props.t("Résultats")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/Documents">{props.t("Principale")}</Link>
                </li>
                <li>
                  <Link to="/Controle">{props.t("Contrôle")}</Link>
                </li>
              </ul>
            </li>
            {mastere === 1 ? (
              <li>
                <Link to="/Mastere" className="">
                  <i className="fas fa-graduation-cap"></i>
                  <span>{props.t("Mastère")}</span>
                </Link>
              </li>
            ) : null}
            {(cycle_id === 1 && niveau_id === 3) ||
            (cycle_id === 2 && niveau_id === 2) ? (
              <li>
                <Link to="/Encadrement" className="">
                  <i className="fas fa-graduation-cap"></i>
                  <span>{props.t("Encadrement")}</span>
                </Link>
              </li>
            ) : null}
            {/*{etat === 1  && etat_orientation == 1? (*/}
            {etat === 1 ? (
              <li>
                <Link to="/Orientation" className="">
                  <i className="fas fa-clipboard-list blinking"></i>
                  <span className="blinking">{props.t("Orientation")}</span>
                </Link>
              </li>
            ) : (
              <li>
                <Link to="/Orientation" className="">
                  <i className="fas fa-clipboard-list blinking"></i>
                  <span className="blinking">{props.t("Orientation")}</span>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
